import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getMembership } from '@techstyle/react-accounts';

import { trackPDPLearnMoreEvent } from '../../actions/cart';
import { trackViewedPdpImage } from '../../actions/products';
import {
  getMembershipCartItem,
  isExclusiveProduct,
  isCurvySize,
  isProductCustomizable,
  isLinkedProductCustomizable,
  isPreorderable,
} from '../../utils/selectors';

import ProductDetailLayout from './ProductDetailLayout';

export function mapStateToProps(state, ownProps) {
  return {
    hasMembershipItem: !!getMembershipCartItem(state),
    isCurvy: isCurvySize(state, ownProps),
    isProductCustomizable: isProductCustomizable(state, ownProps),
    isExclusive: isExclusiveProduct(state, ownProps),
    isLead: getMembership(state).isLead,
    isLinkedProductCustomizable: isLinkedProductCustomizable(state, ownProps),
    isPreorderable: isPreorderable(state, ownProps),
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      trackPDPLearnMoreEvent,
      trackViewedPdpImage,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetailLayout);
